import PropTypes from 'prop-types';
import styled from 'styled-components';
import LazyLoadedImage from '../../LazyLoadedImage/LazyLoadedImage';

const StickerImage = styled.div`
  .resultList & {
    width: auto;
    height: auto;
    background: none !important;
    box-shadow: none;
    padding: 0;
    top: -10px;
    overflow: visible;

    img {
      display: block;
    }
  }
`;
const ListItemStickerImage = ({ loadImagesLazily, stickerImage }) => (
  <StickerImage className={'sticker stickerImg'}>
    {loadImagesLazily ? (
      <LazyLoadedImage
        src={stickerImage.src}
        alt={stickerImage.alt ? stickerImage.alt : undefined}
      />
    ) : (
      <img src={stickerImage.src} alt={stickerImage.alt ? stickerImage.alt : undefined} />
    )}
  </StickerImage>
);

ListItemStickerImage.propTypes = {
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }).isRequired,
  loadImagesLazily: PropTypes.bool
};

ListItemStickerImage.defaultProps = {
  loadImagesLazily: false
};

export default ListItemStickerImage;
